import React, { useState } from 'react';
import { 
  FaBox, FaIdCard, FaWarehouse, FaCashRegister, FaChartPie, 
  FaFileAlt, FaImages, FaBookOpen, FaCheckCircle, FaCogs, 
  FaCode, FaShieldAlt, FaUsers, FaRocket, FaArrowRight,
  FaPlay, FaEye, FaEyeSlash, FaPaperPlane, FaHeadset,
  FaGlobe, FaLaptopCode, FaMobileAlt, FaPalette, FaSearch,
  FaShoppingCart, FaBuilding
} from 'react-icons/fa';

const Products = ({ setPage }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [expandedFeature, setExpandedFeature] = useState(null);
  const [showSenidekScreenshot, setShowSenidekScreenshot] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const showNotification = (message, type = 'info') => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: '', type: '' });
    }, 4000);
  };

  const products = [
    {
      id: 'senidek',
      name: 'Senidek Sales & Inventory Management',
      icon: <FaBox className="product-icon-svg" />,
      logo: '/senideksaaslogo.png',
      screenshot: '/senideksaas.jpg',
      badge: 'Custom SaaS',
      badgeColor: '#2563eb',
      tagline: 'Complete business management solution for modern enterprises',
      description: 'Transform your business operations with our comprehensive ERP solution. Streamline inventory, boost sales, and gain real-time insights.',
      isCustom: true,
      features: [
        {
          title: 'Inventory Management',
          icon: <FaWarehouse />,
          items: [
            'Real-time stock tracking across multiple warehouses',
            'Low stock alerts & automated reorder notifications',
            'Multi-warehouse support with inventory transfer',
            'Barcode scanning integration for quick updates',
            'Batch and expiry date tracking'
          ]
        },
        {
          title: 'Sales Management',
          icon: <FaCashRegister />,
          items: [
            'Professional invoicing & billing system',
            'Multiple payment gateway integration',
            'Sales analytics & performance reporting',
            'Customer management with purchase history',
            'Automated tax calculations'
          ]
        },
        {
          title: 'Analytics & Insights',
          icon: <FaChartPie />,
          items: [
            'Real-time interactive dashboards',
            'Profit margin & revenue analysis',
            'Sales forecasting with AI predictions',
            'Custom report generation',
            'Export data to Excel/PDF'
          ]
        }
      ]
    },
    {
      id: 'tarik',
  name: 'Yene Tarik',
  icon: <FaIdCard className="product-icon-svg" />,
  logo: '/tarik.png',
  badge: 'Creative Studio',
  badgeColor: '#7c3aed',
  tagline: 'CV • Portfolio • Catalog Builder',
  taglineAmharic: 'የኔ ታሪክ • ሲቪ • ፖርትፎሊዮ • ካታሎግ ማበጀት',
  description: 'Create stunning CVs, showcase your work with beautiful portfolios, and build professional catalogs effortlessly.',
  isCustom: false,
      features: [
        {
          title: 'CV Builder / ሲቪ ማበጀት',
          icon: <FaFileAlt />,
          items: [
            '50+ professionally designed templates',
            'AI-powered content suggestions & optimization',
            'One-click PDF & Word export',
            'ATS-friendly formatting for job applications',
            'Multi-language support'
          ]
        },
        {
          title: 'Portfolio Builder / ፖርትፎሊዮ ማበጀት',
          icon: <FaImages />,
          items: [
            'Drag-and-drop visual design interface',
            'Project showcase gallery with filtering',
            'Customizable themes & color schemes',
            'Client testimonials integration',
            'Live preview & sharing options'
          ]
        },
        {
          title: 'Catalog Builder / ካታሎግ ማበጀት',
          icon: <FaBookOpen />,
          items: [
            'Product catalog creation with templates',
            'Pricing & inventory integration',
            'Digital & print-ready formats',
            'Multi-language & currency support',
            'QR code generation for products'
          ]
        }
      ]
    },
    {
      id: 'website',
      name: 'Professional Website Building Service',
      icon: <FaGlobe className="product-icon-svg" />,
      logo: '/logo.png',
      badge: 'Web Development',
      badgeColor: '#f59e0b',
      tagline: 'Custom websites built with modern technologies',
      description: 'We build professional, responsive, and high-performance websites tailored to your business needs. From landing pages to complex e-commerce platforms.',
      isCustom: true,
      features: [
        {
          title: 'Custom Design',
          icon: <FaPalette />,
          items: [
            'Unique, modern UI/UX design tailored to your brand',
            'Responsive design for all devices (desktop, tablet, mobile)',
            'Accessibility-first design principles',
            'Custom animations and interactions',
            'Brand identity integration'
          ]
        },
        {
          title: 'Development & Technology',
          icon: <FaLaptopCode />,
          items: [
            'React.js frontend for dynamic, fast websites',
            'PHP backend with MySQL database',
            'CMS integration (WordPress, Strapi, etc.)',
            'E-commerce functionality with payment gateways',
            'API integration for third-party services'
          ]
        },
        {
          title: 'Performance & SEO',
          icon: <FaSearch />,
          items: [
            'Optimized for speed and performance',
            'SEO-friendly architecture and meta tags',
            'Google Analytics & Search Console integration',
            'Image optimization and lazy loading',
            'SSL certificate installation'
          ]
        },
        {
          title: 'Additional Services',
          icon: <FaShoppingCart />,
          items: [
            'Custom domain setup and hosting',
            'Maintenance & support packages',
            'Content creation and copywriting',
            'Social media integration',
            'Email marketing setup'
          ]
        }
      ]
    },
    {
      id: 'erp',
      name: 'Custom ERP Development',
      icon: <FaCogs className="product-icon-svg" />,
      logo: '/logo.png',
      badge: 'Enterprise',
      badgeColor: '#059669',
      tagline: 'Tailor-made ERP solutions for your business',
      description: 'We build custom ERP systems designed specifically for your business needs. From inventory management to HR, accounting, and beyond.',
      isCustom: true,
      features: [
        {
          title: 'Fully Customizable',
          icon: <FaCogs />,
          items: [
            'Built to match your exact business processes',
            'Scalable architecture for growing businesses',
            'Custom modules for specific needs',
            'Integration with existing systems',
            'Flexible workflow automation'
          ]
        },
        {
          title: 'Modern Tech Stack',
          icon: <FaCode />,
          items: [
            'React frontend for modern UI/UX',
            'PHP backend with MySQL database',
            'RESTful API architecture',
            'Mobile-responsive design',
            'Cloud-ready deployment'
          ]
        },
        {
          title: 'Enterprise Security',
          icon: <FaShieldAlt />,
          items: [
            'Bank-grade encryption & security',
            'Role-based access control',
            'Audit trail & compliance',
            'Regular security updates',
            'Data backup & recovery'
          ]
        },
        {
          title: 'User-Friendly',
          icon: <FaUsers />,
          items: [
            'Intuitive interface for all users',
            'Comprehensive training & support',
            'Multi-language support',
            'Customizable dashboards',
            'User feedback integration'
          ]
        }
      ]
    }
  ];

  const handleProductClick = (productId, e) => {
    e.stopPropagation();
    setSelectedProduct(selectedProduct === productId ? null : productId);
    if (selectedProduct === productId) {
      setExpandedFeature(null);
      setShowSenidekScreenshot(false);
    }
  };

  const handleFeatureClick = (index, e) => {
    e.stopPropagation();
    setExpandedFeature(expandedFeature === index ? null : index);
  };

  const handleDemo = (productName, e) => {
    e.stopPropagation();
    showNotification(`🎯 Demo requested for: ${productName}. Our team will contact you shortly!`, 'success');
    setTimeout(() => setPage('contact'), 1500);
  };

  const handleContact = (e) => {
    e.stopPropagation();
    setPage('contact');
  };

  const handleLaunchApp = (productName, e) => {
    e.stopPropagation();
    if (productName.includes('Senidek')) {
      setShowSenidekScreenshot(!showSenidekScreenshot);
      if (!showSenidekScreenshot) {
        showNotification('📸 System preview loaded! Click again to hide.', 'info');
      }
    } else if (productName.includes('Custom ERP')) {
      showNotification('🏢 Custom ERP Development - Discuss your requirements with our team!', 'info');
      setTimeout(() => setPage('contact'), 1500);
    } else if (productName.includes('Website')) {
      showNotification('🌐 Website Building Service - Let us create your dream website!', 'info');
      setTimeout(() => setPage('calculator'), 1500);
    } else if (productName.includes('Tarik')) {
      showNotification('🚀 Tarik Studio is coming soon! Get ready to create stunning CVs, portfolios, and catalogs.', 'info');
    } else {
      showNotification('🚀 Coming soon!', 'info');
    }
  };

  return (
    <div className="products page-enter">
      {/* Notification Toast */}
      {notification.show && (
        <div className={`notification-toast ${notification.type}`}>
          <div className="toast-content">
            <span className="toast-icon">
              {notification.type === 'success' ? '✅' : 'ℹ️'}
            </span>
            <span>{notification.message}</span>
          </div>
        </div>
      )}

      {/* Background Logo Watermark */}
      <div className="background-logo-container">
        <img src="/logo.png" alt="Senidek Technology" className="background-logo" />
      </div>

      {/* Header */}
      <div className="products-header">
        <div className="header-decoration">
          <span className="products-badge">🚀 Enterprise Solutions</span>
        </div>
        <h2>Our <span>Products</span></h2>
        <p>Powerful solutions to transform your business</p>
        <div className="header-line"></div>
      </div>

      {/* Product Grid */}
      <div className="products-grid">
        {products.map((product) => (
          <div 
            key={product.id}
            className={`product-card ${selectedProduct === product.id ? 'expanded' : ''}`}
            onClick={(e) => handleProductClick(product.id, e)}
            onMouseEnter={() => setHoveredProduct(product.id)}
            onMouseLeave={() => setHoveredProduct(null)}
          >
            <div className="card-gradient-border"></div>

            <div className="product-card-header">
              <div className={`product-card-icon-wrapper ${hoveredProduct === product.id ? 'hovered' : ''}`}>
                {product.logo ? (
                  <img 
                    src={product.logo} 
                    alt={product.name} 
                    className="product-card-logo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                ) : (
                  <span className="product-card-icon-svg">{product.icon}</span>
                )}
              </div>
              <div className="product-card-info">
                <h3>{product.name}</h3>
                {product.taglineAmharic ? (
                  <>
                    <p className="product-tagline">{product.tagline}</p>
                    <p className="product-tagline-amharic">{product.taglineAmharic}</p>
                  </>
                ) : (
                  <p className="product-tagline">{product.tagline}</p>
                )}
                <span className="product-card-badge" style={{ background: product.badgeColor }}>
                  {product.badge}
                </span>
              </div>
              <div className="product-card-expand">
                <span className={`expand-icon ${selectedProduct === product.id ? 'rotated' : ''}`}>
                  {selectedProduct === product.id ? '−' : '+'}
                </span>
              </div>
            </div>

            <div className={`product-card-content ${selectedProduct === product.id ? 'open' : ''}`}>
              <p className="product-card-description">{product.description}</p>

              {product.id === 'senidek' && showSenidekScreenshot && (
                <div className="screenshot-preview">
                  <img src={product.screenshot} alt="Senidek SaaS Dashboard" className="screenshot-image" />
                  <div className="screenshot-label">📸 System Preview - Senidek Sales & Inventory</div>
                </div>
              )}

              <div className="product-features-container">
                <h4>✨ Key Features</h4>
                <div className="product-features-grid">
                  {product.features.map((feature, index) => (
                    <div 
                      key={index}
                      className={`feature-item ${expandedFeature === index ? 'expanded' : ''}`}
                      onClick={(e) => handleFeatureClick(index, e)}
                    >
                      <div className="feature-header">
                        <span className="feature-icon">{feature.icon}</span>
                        <span className="feature-title">{feature.title}</span>
                        <span className="feature-toggle">
                          {expandedFeature === index ? '−' : '+'}
                        </span>
                      </div>
                      <ul className={`feature-list ${expandedFeature === index ? 'open' : ''}`}>
                        {feature.items.map((item, idx) => (
                          <li key={idx}>
                            <FaCheckCircle className="feature-check" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              <div className="product-card-actions">
                {product.id === 'website' ? (
                  <>
                    <button 
                      className="btn-primary action-btn" 
                      onClick={(e) => handleLaunchApp(product.name, e)}
                    >
                      <FaGlobe /> Get Website Quote
                    </button>
                    <button 
                      className="btn-outline action-btn"
                      onClick={(e) => handleContact(e)}
                    >
                      <FaPaperPlane /> Contact Sales
                    </button>
                  </>
                ) : product.id === 'erp' ? (
                  <>
                    <button 
                      className="btn-primary action-btn" 
                      onClick={(e) => handleLaunchApp(product.name, e)}
                    >
                      <FaHeadset /> Discuss ERP Needs
                    </button>
                    <button 
                      className="btn-outline action-btn"
                      onClick={(e) => handleContact(e)}
                    >
                      <FaPaperPlane /> Contact Sales
                    </button>
                  </>
                ) : product.isCustom ? (
                  <>
                    <button 
                      className={`btn-primary action-btn ${showSenidekScreenshot ? 'active' : ''}`}
                      onClick={(e) => handleLaunchApp(product.name, e)}
                    >
                      {showSenidekScreenshot ? <FaEyeSlash /> : <FaEye />}
                      {showSenidekScreenshot ? 'Hide Preview' : 'View System Preview'}
                    </button>
                    <button 
                      className="btn-outline action-btn"
                      onClick={(e) => handleDemo(product.name, e)}
                    >
                      <FaPlay /> Request Demo
                    </button>
                  </>
                ) : (
                  <>
                    <button 
                      className="btn-primary action-btn" 
                      onClick={(e) => handleLaunchApp(product.name, e)}
                    >
                      <FaRocket /> Coming Soon
                    </button>
                    <button 
                      className="btn-outline action-btn"
                      onClick={(e) => handleContact(e)}
                    >
                      <FaPaperPlane /> Contact Sales
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .products {
          padding: 10px 0 30px;
          position: relative;
          overflow: hidden;
        }

        /* ===== NOTIFICATION TOAST ===== */
        .notification-toast {
          position: fixed;
          top: 20px;
          right: 20px;
          padding: 16px 24px;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          z-index: 9999;
          max-width: 450px;
          box-shadow: 0 8px 30px rgba(0,0,0,0.2);
          animation: slideInRight 0.5s ease;
          backdrop-filter: blur(10px);
        }

        .toast-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .toast-icon {
          font-size: 1.2rem;
        }

        .notification-toast.info {
          background: linear-gradient(135deg, #2563eb, #7c3aed);
        }

        .notification-toast.success {
          background: linear-gradient(135deg, #059669, #10b981);
        }

        .notification-toast.error {
          background: linear-gradient(135deg, #dc2626, #ef4444);
        }

        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        /* ===== BACKGROUND LOGO ===== */
        .background-logo-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 700px;
          height: 700px;
          opacity: 0.03;
          pointer-events: none;
          z-index: 0;
        }

        .background-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        /* ===== HEADER ===== */
        .products-header {
          text-align: center;
          margin-bottom: 40px;
          position: relative;
          z-index: 1;
        }

        .header-decoration {
          display: flex;
          justify-content: center;
        }

        .products-badge {
          display: inline-block;
          background: linear-gradient(135deg, var(--primary-light), var(--gray-50));
          color: var(--primary);
          padding: 6px 24px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 12px;
          letter-spacing: 0.5px;
          border: 1px solid var(--primary-light);
        }

        .products-header h2 {
          font-size: 2.8rem;
          font-weight: 800;
          color: var(--gray-900);
          margin-bottom: 8px;
        }

        .products-header h2 span {
          color: var(--primary);
          position: relative;
        }

        .products-header h2 span::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--primary-light);
          border-radius: 2px;
          z-index: -1;
        }

        .products-header p {
          font-size: 1.15rem;
          color: var(--gray-500);
        }

        .header-line {
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, var(--primary), var(--accent));
          border-radius: 2px;
          margin: 16px auto 0;
        }

        /* ===== PRODUCT TAGLINE ===== */
        .product-tagline {
          font-size: 0.9rem;
          color: var(--gray-600);
          margin: 2px 0;
          font-weight: 500;
        }

        .product-tagline-amharic {
          font-size: 0.85rem;
          color: var(--gray-500);
          margin: 2px 0;
          font-family: 'Segoe UI', 'Ethiopic', sans-serif;
        }

        /* ===== PRODUCT GRID ===== */
        .products-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 28px;
          max-width: 960px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        /* ===== PRODUCT CARD ===== */
        .product-card {
          background: white;
          border-radius: var(--radius-lg);
          border: 2px solid var(--gray-200);
          padding: 28px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          position: relative;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

        .product-card::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.02), rgba(124, 58, 237, 0.02));
          opacity: 0;
          transition: opacity 0.4s ease;
          pointer-events: none;
        }

        .product-card:hover::after {
          opacity: 1;
        }

        .card-gradient-border {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb);
          background-size: 200% 100%;
          opacity: 0;
          transition: opacity 0.4s ease;
          animation: shimmer 3s ease-in-out infinite;
        }

        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        .product-card:hover {
          border-color: var(--primary-light);
          box-shadow: 0 8px 30px rgba(37, 99, 235, 0.1);
          transform: translateY(-3px);
        }

        .product-card:hover .card-gradient-border {
          opacity: 1;
        }

        .product-card.expanded {
          border-color: var(--primary);
          box-shadow: 0 12px 40px rgba(37, 99, 235, 0.15);
        }

        .product-card.expanded .card-gradient-border {
          opacity: 1;
        }

        /* ===== CARD HEADER ===== */
        .product-card-header {
          display: flex;
          align-items: center;
          gap: 18px;
          pointer-events: none;
        }

        .product-card-header > * {
          pointer-events: none;
        }

        .product-card-icon-wrapper {
          width: 72px;
          height: 72px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          overflow: hidden;
          background: linear-gradient(135deg, var(--gray-50), var(--gray-100));
          border: 2px solid var(--gray-200);
          transition: all 0.4s ease;
        }

        .product-card-icon-wrapper.hovered {
          border-color: var(--primary);
          transform: scale(1.05) rotate(-3deg);
          box-shadow: 0 4px 16px rgba(37, 99, 235, 0.15);
        }

        .product-card-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 10px;
        }

        .product-card-icon-svg {
          font-size: 2.2rem;
          color: var(--primary);
        }

        .product-card-info {
          flex: 1;
        }

        .product-card-info h3 {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--gray-900);
          margin-bottom: 2px;
          transition: color 0.3s ease;
        }

        .product-card:hover .product-card-info h3 {
          color: var(--primary);
        }

        .product-card-badge {
          display: inline-block;
          padding: 2px 14px;
          border-radius: 50px;
          font-size: 0.7rem;
          font-weight: 600;
          color: white;
          letter-spacing: 0.3px;
          text-transform: uppercase;
          margin-top: 4px;
        }

        .product-card-expand {
          flex-shrink: 0;
          pointer-events: none;
        }

        .expand-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: var(--gray-100);
          font-size: 1.5rem;
          font-weight: 300;
          color: var(--gray-600);
          transition: all 0.3s ease;
        }

        .expand-icon.rotated {
          background: var(--primary);
          color: white;
          transform: rotate(180deg);
        }

        /* ===== CARD CONTENT ===== */
        .product-card-content {
          max-height: 0;
          overflow: hidden;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          opacity: 0;
        }

        .product-card-content.open {
          max-height: 2000px;
          opacity: 1;
          padding-top: 24px;
        }

        .product-card-description {
          font-size: 0.95rem;
          color: var(--gray-600);
          line-height: 1.7;
          margin-bottom: 20px;
        }

        /* ===== SCREENSHOT ===== */
        .screenshot-preview {
          margin: 16px 0;
          border-radius: 14px;
          overflow: hidden;
          border: 2px solid var(--gray-200);
          background: var(--gray-50);
          animation: slideUp 0.5s ease;
        }

        .screenshot-image {
          width: 100%;
          height: auto;
          display: block;
          max-height: 400px;
          object-fit: cover;
        }

        .screenshot-label {
          padding: 10px 20px;
          background: linear-gradient(135deg, var(--primary), var(--accent));
          color: white;
          font-size: 0.85rem;
          font-weight: 600;
          text-align: center;
          letter-spacing: 0.3px;
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* ===== FEATURES ===== */
        .product-features-container h4 {
          font-size: 1rem;
          font-weight: 600;
          color: var(--gray-800);
          margin-bottom: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .product-features-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 10px;
          margin-bottom: 24px;
        }

        .feature-item {
          background: var(--gray-50);
          border-radius: 12px;
          padding: 14px 18px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }

        .feature-item:hover {
          background: var(--gray-100);
          border-color: var(--gray-200);
        }

        .feature-item.expanded {
          background: white;
          border-color: var(--primary-light);
          box-shadow: 0 2px 12px rgba(37, 99, 235, 0.08);
        }

        .feature-header {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .feature-icon {
          font-size: 1.3rem;
          color: var(--primary);
          width: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .feature-title {
          flex: 1;
          font-weight: 600;
          font-size: 0.95rem;
          color: var(--gray-800);
        }

        .feature-toggle {
          font-size: 1.2rem;
          font-weight: 300;
          color: var(--gray-400);
          transition: transform 0.3s ease;
        }

        .feature-item.expanded .feature-toggle {
          color: var(--primary);
          transform: rotate(180deg);
        }

        .feature-list {
          list-style: none;
          padding: 0;
          margin: 0;
          max-height: 0;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .feature-list.open {
          max-height: 500px;
          padding-top: 12px;
        }

        .feature-list li {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          padding: 5px 0;
          font-size: 0.9rem;
          color: var(--gray-600);
          line-height: 1.5;
        }

        .feature-check {
          color: var(--success);
          font-size: 0.9rem;
          flex-shrink: 0;
          margin-top: 2px;
        }

        /* ===== ACTIONS ===== */
        .product-card-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 8px;
        }

        .action-btn {
          flex: 1;
          min-width: 150px;
          justify-content: center;
          pointer-events: auto;
          transition: all 0.3s ease;
          font-weight: 600;
          padding: 14px 28px;
          gap: 10px;
        }

        .action-btn svg {
          font-size: 1rem;
        }

        .btn-primary.active {
          background: var(--accent);
          box-shadow: 0 4px 14px rgba(124, 58, 237, 0.35);
        }

        .btn-primary.active:hover {
          background: #6d28d9;
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 1024px) {
          .products-header h2 { font-size: 2.4rem; }
          .background-logo-container { width: 500px; height: 500px; }
        }

        @media (max-width: 768px) {
          .products-header h2 { font-size: 2rem; }
          .products-header p { font-size: 1rem; }
          .product-card { padding: 20px; }
          .product-card-icon-wrapper { width: 56px; height: 56px; }
          .product-card-info h3 { font-size: 1rem; }
          .product-tagline { font-size: 0.8rem; }
          .product-tagline-amharic { font-size: 0.75rem; }
          .product-card-actions { flex-direction: column; }
          .action-btn { width: 100%; }
          .screenshot-image { max-height: 250px; }
          .background-logo-container { width: 350px; height: 350px; }
          .notification-toast {
            max-width: 90%;
            right: 10px;
            top: 10px;
            padding: 12px 18px;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .products-header h2 { font-size: 1.6rem; }
          .product-card { padding: 16px; }
          .product-card-icon-wrapper { width: 48px; height: 48px; border-radius: 14px; }
          .product-card-logo { padding: 6px; }
          .product-card-info h3 { font-size: 0.9rem; }
          .product-tagline { font-size: 0.75rem; }
          .product-tagline-amharic { font-size: 0.7rem; }
          .feature-item { padding: 10px 14px; }
          .feature-title { font-size: 0.85rem; }
          .feature-list li { font-size: 0.8rem; }
          .screenshot-image { max-height: 180px; }
          .background-logo-container { width: 250px; height: 250px; }
          .products-badge { font-size: 0.75rem; padding: 4px 16px; }
          .action-btn { padding: 12px 20px; font-size: 0.9rem; }
        }
      `}</style>
    </div>
  );
};

export default Products;